import { trackSaveHealthData } from "core/monitoring/Events";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { t } from "i18next";
import { useState } from "react";
import { IntegerInput } from "shared/UI/Inputs/IntegerInput/IntegerInput";
import { ConfirmationModal } from "shared/UI/Modal/ConfirmationModal/ConfirmationModal";

export const StepsInputModal = ({ onClose }: { onClose: VoidFunction }) => {
  const { handlePositiveMoment } = useAppReviewContext();
  const { getCurrentTrackerValue, setTrackerData } = useTrackerContext();
  const [stepCount, setStepCount] = useState<number | undefined>(undefined);

  const onSave = async () => {
    trackSaveHealthData(TrackerType[TrackerType.Steps]);
    setTrackerData(TrackerType.Steps, stepCount!);
    onClose();
    handlePositiveMoment();
  };

  return (
    <ConfirmationModal
      title={t("wellbeing.trackers.steps.addData.heading")}
      cancelButtonText={t("wellbeing.trackers.steps.addData.cancel")}
      confirmButtonText={t("wellbeing.trackers.steps.addData.save")}
      confirmButtonDisabled={!stepCount || stepCount < 0}
      onCancel={onClose}
      onConfirm={onSave}
    >
      <div>
        <IntegerInput
          aria-label={t("wellbeing.trackers.steps.addData.inputLabel")}
          defaultValue={String(getCurrentTrackerValue(TrackerType.Steps))}
          onChange={(e) => setStepCount(parseInt(e.target.value))}
          min={1}
          maxLength={5}
          suffix={t("wellbeing.trackers.steps.addData.inputSuffix")}
        />
      </div>
    </ConfirmationModal>
  );
};
